export default "__VITE_ASSET__nCZQCxdQ__"